module.exports = __webpack_public_path__ + "static/media/symbolLogoWhite.4beeb356.svg";